import { render, staticRenderFns } from "./DeletedUsers.vue?vue&type=template&id=3b901820"
import script from "./DeletedUsers.vue?vue&type=script&lang=js"
export * from "./DeletedUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports